import Flickity from "../externals/flickity/wwdevFlickity";

class productVisual {
	constructor(config) {
		this.config = Object.assign({
			scope: '.product_visual'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		var flkty = new Flickity('.product_carousel');
		var carouselStatus = document.querySelector('.counter-product-visual');

		function updateStatus() {
			var slideNumber = flkty.selectedIndex + 1;
			carouselStatus.textContent = slideNumber + ' ' + '/' + ' ' + flkty.slides.length + ' ';
		}
		updateStatus();

		flkty.on( 'select', updateStatus );
	}
}

export default new productVisual;